module.exports = __webpack_public_path__ + "static/img/zunyi.0c9d046.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/font/zunyi.png
// module id = yD01
// module chunks = 1